'use client'
import * as React from 'react'
import { tw } from 'utils/classnames'
import { useInView } from 'framer-motion'
import { useUserQuery } from 'auth/hooks'
import { isLoggedInQuerySelector } from 'auth/selectors'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import { LFS_URL } from '@web/utils/env'
import { ReviewsTab } from './reviews-tab'
import { Widget } from './widget'

export function StickyContainer() {
  const t = useTranslations('pages.subscription')

  const compareTableElement = React.useRef<HTMLDivElement>(null)

  const isVisible = useInView(compareTableElement, { margin: '-30% 0% 0% 0%' })
  const { data: userData } = useUserQuery()
  const isUserLoggedIn = isLoggedInQuerySelector(userData)

  const isEligibleForAllAccessFreeTrial =
    userData?.me?.user?.subscriptionAccess.allAccess.isEligibleForFreeTrial
  const hideFreeTrial = isUserLoggedIn && !isEligibleForAllAccessFreeTrial

  return (
    <>
      <section
        id="compare-features"
        className={tw(
          'bg-cf-white grid w-full pt-4 font-bold',
          isVisible && 'sticky top-0 isolate',
          hideFreeTrial
            ? 'grid-cols-1 lg:grid-cols-[1fr,minmax(0,_356px)]'
            : 'grid-cols-2 lg:grid-cols-[1fr,minmax(0,_356px),minmax(0,_344px)]',
        )}
      >
        <div className="col-span-full mb-[10px] flex items-center justify-center gap-3 lg:col-span-1 lg:mb-0 lg:mr-5 lg:min-w-[350px] lg:justify-start">
          <Image
            width={116}
            height={99}
            src={`${LFS_URL}/web/pages/subscription/SubscriptionPlan_Icon.png`}
            alt="Subscription Plan Icon"
            className="min-h-[76px] min-w-[81px]"
          />

          <p className="text-16 font-bold">{t('compare.title')}</p>
        </div>
        {hideFreeTrial ? null : (
          <div className="flex px-2 lg:mx-1 lg:px-0 lg:pr-2">
            <Widget type="free_trial" variant="small" />
          </div>
        )}
        <div className="flex px-2 lg:mx-1 lg:px-0 lg:pr-2">
          <Widget type="all_access_yearly" variant="small" />
        </div>
      </section>
      <section className="mt-10" ref={compareTableElement}>
        <ReviewsTab />
      </section>
    </>
  )
}
